import { pageLoaderController } from "../../../context/PageLoaderContext";
import { devError, devLog, devWarn } from "../../../utils/devLogger";

interface CallCommonApiParams {
  title: string;
  url: string;
  formData: FormData;
  isCallPageLoader?: boolean;
}

export async function callCommonApi<T = any>({
  title,
  url,
  formData,
  isCallPageLoader = false,
}: CallCommonApiParams): Promise<T> {
  // 환경에 따른 API URL 분기 처리
  let apiUrl = url;
  if (typeof window !== 'undefined') {
    // 상대경로인 경우에만 API 호스트 붙이기
    if (url.startsWith('/')) {
      const apiHost = process.env.NEXT_PUBLIC_API_HOST;
      
      devLog(`🔍 [callCommonApi] API_HOST: ${apiHost}`);
      devLog(`🔍 [callCommonApi] URL: ${url}`);
      
      if (!apiHost) {
        const errorMsg = `❌ [callCommonApi] NEXT_PUBLIC_API_HOST 환경변수가 설정되지 않았습니다.`;
        devError(errorMsg);
        devLog(errorMsg);
        throw new Error('API 호스트가 설정되지 않았습니다.');
      }
      
      apiUrl = `${apiHost}${url}`;
    }
  }

  devLog(`�📦 [${title}] ${typeof window !== 'undefined' ? `(${window.location.protocol})` : ''}`, apiUrl);
  
  // 🔧 모바일 대응: FormData 내용 상세 로깅
  devLog(`📱 [${title}] FormData 내용:`);
  Array.from(formData.entries()).forEach(([key, value]) => {
    if (value instanceof File) {
      devLog(`  📁 ${key}:`, {
        name: value.name,
        size: value.size,
        type: value.type,
        lastModified: value.lastModified
      });
    } else {
      devLog(`  📝 ${key}:`, value);
    }
  });
  
  if (isCallPageLoader) pageLoaderController.open();

  let returnValue = "";

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      body: formData,
      // credentials: "include",
    });

    returnValue = await response.text();
    devLog(`📱 [${title}] HTTP 상태:`, response.status, response.statusText);
    devLog(`📦 [${title}] 응답`, returnValue);
    
    // 🔧 응답이 비어있거나 잘못된 경우 처리
    if (!returnValue || returnValue.trim() === '') {
      devWarn(`⚠️ [${title}] 빈 응답 수신`);
      returnValue = '[]';
    }
    
  } catch (error) {
    // API 요청 에러 시 조용히 빈 배열 응답으로 설정
    returnValue = "[]";
  } finally {
    if (isCallPageLoader) pageLoaderController.close();
  }

  try {
    const parsed = JSON.parse(returnValue);
    devLog(`📱 [${title}] 파싱된 응답:`, parsed);
    return parsed;
  } catch (e) {
    // JSON 파싱 실패 시 조용히 빈 배열 반환
    return [] as T;
  }
}
